/**
 * @file contains subscription exchange config for urql
 */
import { createClient as createWSClient } from 'graphql-ws';
import { Exchange, subscriptionExchange } from 'urql';

import { GRAPHQL_SUBSCRIPTIONS_URL } from '../../../config';

import { getHotelIdFromUrl } from '../../hotel';
import { getAuthToken } from '../../storage/auth';

const wsClient = createWSClient({
  /**
   * Only connect after the first subscription is fired, this is needed because `hotelId`,
   * is not available in the url at start of the app (no hotelId in /). This can create a race condition
   * (if first sub happens while we are on /).
   *
   * @returns The params to use
   */
  connectionParams: () => ({
    Authorization: `Bearer ${getAuthToken()}`,
    HotelId: getHotelIdFromUrl(),
  }),
  lazy: true,
  url: GRAPHQL_SUBSCRIPTIONS_URL,
});

const exchange: Exchange = subscriptionExchange({
  forwardSubscription: request => ({
    subscribe: sink => {
      const unsubscribe = wsClient.subscribe(
        { ...request, query: request.query ?? '' },
        sink,
      );
      return { unsubscribe };
    },
  }),
});

export default exchange;
